import api from "./client";

// AI Proposals inbox — the surface where PENDING agent/watcher proposals get
// reviewed. Watcher proposals have conversation_id=None (no chat thread to live
// in), so without this list they'd rot in a table. Same {action_id, tool,
// confirmation, shadow, requires_confirm} card shape as converse, plus
// created_at + surface/rule labels + a subject context line.
//
//   GET  /agent/proposals/?status=pending&surface=&rule=&limit=&cursor=
//     -> { proposals: [...], counts: { total, by_rule, by_surface }, next }
//   POST /agent/proposals/bulk-decline/  { action_ids, reason? }
//     -> { declined: [...], failed: [{ action_id, error }] }
//
// Per-card confirm/decline reuse the same endpoints the chat panel wired
// (see agentApi.js): /agent/confirm/ and /agent/decline/.

const AGENT_TIMEOUT = 90000; // agent/watcher ops are LLM-backed; the app default 20s is too short

export const listProposals = ({ status = "pending", surface, rule, limit = 50, cursor } = {}) =>
  api.get("/agent/proposals/", {
    params: {
      status,
      ...(surface ? { surface } : {}),
      ...(rule ? { rule } : {}),
      limit,
      ...(cursor ? { cursor } : {}),
    },
  });

export const bulkDecline = (actionIds, reason) =>
  api.post("/agent/proposals/bulk-decline/", {
    action_ids: actionIds,
    ...(reason ? { reason } : {}),
  }, { timeout: AGENT_TIMEOUT });

export { confirmAction, declineAction } from "./agentApi";
